import Vue from 'vue'
import { getState } from './state'

const RESET_STATE = state => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

const CHANGE_STEP = (state, step) => {
    state.activeStep = step
}

const SET_CONTEXT = (state, id) => {
    state.context = id
}

const TOGGLE_MODAL = state => {
    state.showModal = !state.showModal
}

const SET_DATA_SUCCESS = (state, data) => {
    state[state.activeStep] = data
    state.success = true
}

const SET_DATA_FAILURE = (state, error) => {
    state.error = error
}

const TOGGLE_PNL_INPUT = state => {
    state.showInput = !state.showInput
}

const RESET_PNL_STATE = state => {
    state.error = false
    state.success = false
    state.showInput = true
    state.pnl = {
        data: {
            date: null,
            file_name: null,
            income: [],
            income_category_list: [],
            meta: {},
            opex: [],
            opex_category_list: []
        }
    }
}

const SET_REPORTS = (state, payload) => {
    state.reports = payload
}

const SET_LOADING = state => {
    state.loading = true
}

const RESET_LOADING = state => {
    state.loading = false
}

const REMOVE_REPORT = state => {}

export default {
    CHANGE_STEP,
    RESET_STATE,
    SET_CONTEXT,
    SET_REPORTS,
    TOGGLE_MODAL,
    SET_LOADING,
    REMOVE_REPORT,
    RESET_LOADING,
    RESET_PNL_STATE,
    TOGGLE_PNL_INPUT,
    SET_DATA_SUCCESS,
    SET_DATA_FAILURE
}



// WEBPACK FOOTER //
// ./src/state/modules/debt-servicing/uploader/mutations.js